import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('pallBearer');
export interface PallBearerRec {
  id: string;
  userId?: string;
  fullName?: string;
  phoneNumber?: string;
  email?: string;
  choice?: string;
  notes?: string;
  isLocked?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

class PallBearerService {

  async getAllPallBearers(): Promise<PallBearerRec[]> {
    try {
      const response = await http.get('/api/pall-bearers');
      return response.data;
    } catch (error) {
      logger.error('Error fetching pall bearers:', error);
      throw error;
    }
  }

  async getPallBearerById(id: string): Promise<PallBearerRec> {
    try {
      const response = await http.get(`/api/pall-bearers/${id}`);
      return response.data;
    } catch (error) {
      logger.error('Error fetching pall bearer by ID:', error);
      throw error;
    }
  }

  async createPallBearer(data: Partial<PallBearerRec>): Promise<PallBearerRec> {
    try {
      const response = await http.post('/api/pall-bearers', data);
      return response.data;
    } catch (error) {
      logger.error('Error creating pall bearer:', error);
      throw error;
    }
  }

  async updatePallBearer(id: string, data: Partial<PallBearerRec>): Promise<PallBearerRec> {
    try {
      const response = await http.put(`/api/pall-bearers/${id}`, data);
      return response.data;
    } catch (error) {
      logger.error('Error updating pall bearer:', error);
      throw error;
    }
  }

  async deletePallBearer(id: string): Promise<void> {
    try {
      await http.delete(`/api/pall-bearers/${id}`);
    } catch (error) {
      logger.error('Error deleting pall bearer:', error);
      throw error;
    }
  }

  async lockPallBearer(id: string): Promise<void> {
    logger.debug('[Service Debug] Calling lock API for pall bearer ID:', id);
    try {
      const response = await http.post(`/api/pall-bearers/${id}/lock`);
      logger.debug('[Service Debug] Lock API response:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to lock pall bearer');
      }
    } catch (error) {
      logger.error('Error locking pall bearer:', error);
      throw error;
    }
  }

  async unlockPallBearer(id: string, granteeEmails: string[]): Promise<void> {
    logger.debug('[Service Debug] Calling unlock API for pall bearer ID:', id, 'granteeEmails:', granteeEmails);
    try {
      const response = await http.post(`/api/pall-bearers/${id}/unlock`, { granteeEmails });
      logger.debug('[Service Debug] Unlock API response:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to unlock pall bearer');
      }
    } catch (error) {
      logger.error('Error unlocking pall bearer:', error);
      throw error;
    }
  }

  async getPallBearerAccessGrants(id: string): Promise<any[]> {
    try {
      const response = await http.get(`/api/pall-bearers/${id}/access-grants`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to fetch pall bearer access grants');
      }

      return response.data.data || [];
    } catch (error) {
      logger.error('Error fetching pall bearer access grants:', error);
      return [];
    }
  }
}

export const pallBearerService = new PallBearerService();